import styled from "@emotion/styled";
import { MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH, MOBILE_QUERY_MAX_WIDTH_M } from "constants/vp-sizes";

export const StyledImageWithParagraphGridComponent = styled.div`
  max-width: ${MAX_DESKTOP_DYNAMIC_TEMPLATE_WIDTH}px;
  margin: auto;
  padding: 0;

  @media (max-width: ${MOBILE_QUERY_MAX_WIDTH_M}) {
    padding: 8px;
  }
`;
